// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sWfXc","label":"styles_label__1EPz6"};